export const BetrGrPV = [
  {
    'PAISY Wert': 0,
    Bezeichnung: 'keine PV',
  },
  {
    'PAISY Wert': 1,
    Bezeichnung: 'voller Beitrag',
  },
  {
    'PAISY Wert': 2,
    Bezeichnung: 'halber Beitrag',
  },
];
